// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4fb149de","667":"041334c6","867":"56013bfb"}[chunkId] + ".chunk.js";
};